import { ForwardedRef, forwardRef } from 'react';
import cn from 'classnames';
import styles from './keto-textarea.module.css';

export interface KetoTextareaProps
  extends React.DetailedHTMLProps<
    React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  > {
  error?: boolean;
  errorMessage?: string;
}

function KetoTextarea(
  { error, errorMessage, className, ...props }: KetoTextareaProps,
  ref: ForwardedRef<HTMLTextAreaElement>,
) {
  return (
    <div className={cn(className, styles.wrapper)}>
      <textarea
        ref={ref}
        {...props}
        className={cn(styles.input, {
          [styles.input_error]: error,
        })}
      />
      {error && <span className={styles.error}>{errorMessage}</span>}
    </div>
  );
}

export default forwardRef(KetoTextarea);
